export default __webpack_public_path__ + "static/media/us.3a3a015e.jpg";